import React, { Component } from 'react';
import SeriesTable from "../../../components/common/SeriesTable";

class PurchaseDocuments extends Component {
    render() {
        return (
            <div className="panel-body">
                <h2>Facturas de compra</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.purchaseInvoicesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Albaranes de compra</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.receiptsSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Pedidos de compra</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.purchaseOrdersSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Proveedores</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.suppliersSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


export default PurchaseDocuments;


// WEBPACK FOOTER //
// ./src/containers/configuration/documents/PurchaseDocuments.js